import { render, staticRenderFns } from "./checkout-content.vue?vue&type=template&id=88aef024&scoped=true&"
import script from "./checkout-content.vue?vue&type=script&lang=js&"
export * from "./checkout-content.vue?vue&type=script&lang=js&"
import style0 from "./checkout-content.vue?vue&type=style&index=0&id=88aef024&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88aef024",
  null
  
)

export default component.exports